<template>
  <div id="news" class="wraps">
    <!-- 
        <img 
    class="banner"
        v-lazy="'https://www.xaryxx.com/images/images2/s30.png'"> -->

    <img class="banner" src="../../assets/banner/news.jpg" alt="" />

    <!-- 新闻和资讯内容 -->
    <div class="content">
      <!-- 导航 -->
      <div class="tabs-nav">
        <div class="nav-content">
          <div
            class="item"
            v-for="(item, index) in navList"
            :key="index"
            @click="showContent(index)"
          >
            <div :class="current == index ? 'active' : ''">
              {{ item.label }}
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 公司动态 -->
      <div class="box" v-if="list.length">
        <div
          style="min-height: 600px"
          class="dynamics-list animate__animated animate__slideInLeft"
        >
          <div
            v-for="(item, index) in list"
            :key="index"
            @click="getNewList(item)"
            class="items"
          >
            <div class="time">
              <div>{{ item.monthDay }}</div>
              <div>{{ item.year }}</div>
            </div>
            <div class="line1"></div>
            <div class="name">
              <div class="tit">{{ item.title }}</div>
              <div class="desc">{{ item.introduction }}</div>
            </div>
            <div class="img">
              <img :src="item.url" alt="" />
            </div>
            <!-- <div class="imgs">
              <img :src="item.url" alt="" />
            </div>
            <div class="bot">
              <div class="tit">{{ item.title }}</div>
              <div class="desc">{{ item.introduction }}</div>
              <div class="time">
                <div>{{ item.publishDate }}</div>
                <div class="more">
                  查看详情
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div v-else class="box">
        <div
          style="min-height: 600px"
          class="animate__animated animate__slideInLeft nodata1"
        >
          <img src="../../assets/banner/empty.png" alt="" />
          <p>暂无数据</p>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination" v-if="list.length">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :page-size="12"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>

      <!-- <sl-pagenation :pages="listData[current]" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" /> -->
    </div>
  </div>
</template>

<script>
import CompanyDynamics from "../common/company-dynamics";
import NewsList from "../common/news-list";
import Pagenation from "@/components/common/Pagenation";
import BannerTitle from "../common/banner-title";
import { information } from "@/api/api";

export default {
  name: "news",
  components: {
    CompanyDynamics,
    NewsList,
    BannerTitle,
    slPagenation: Pagenation,
  },
  data() {
    return {
      navList: [
        { label: "行业动态", value: 1 },
        { label: "企业新闻", value: 2 },
      ],
      current: 0,
      list: [],
      pageSize: 12,
      currentPage: 1,
      total: 0,
      // listData: [
      //   {
      //     // 当前页数量
      //     pageSize: 10,
      //     // 当前页
      //     currentPage: 1,
      //     // 总数
      //     total: 0,
      //     list: []
      //   },
      //   {
      //     // 当前页数量
      //     pageSize: 10,
      //     // 当前页
      //     currentPage: 1,
      //     // 总数
      //     total: 0,
      //     list: []
      //   }
      // ],
      bannerList: [],
    };
  },
  created() {
    this.getNewsList();
  },

  methods: {
    showContent: function (current) {
      this.current = current;
      let self = this;
      //  行业资讯

      this.currentPage = 1;
      this.total = 0;
      this.list = [];
      this.getNewsList();
      // self.listData[self.current].list=[]
    },
    //请求列表数据
    getNewsList() {
      let self = this;
      //  行业资讯

      information({
        pageNum: self.currentPage,
        pageSize: self.pageSize,
        type: self.current + 1,
      })
        .then((result) => {
          self.list = self.list.concat(result.rows);

          if (self.list && self.list.length) {
            self.list = self.list.map((r) => {
              let [year, month,Day] = r.publishDate.split("-");
              return {
                ...r,
                year,
                monthDay:month+'-'+Day,
              };
            });
          }

          self.currentPage++;
          // self.listData[self.current].pageSize = result.data.data.limit;
          self.total = result.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //页面尺寸改变
    handleSizeChange(newSize) {
      this.currentPage = 1;
      this.total = 0;
      this.list = [];

      this.getNewsList();
    },
    //页码改变
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.list = [];
      this.getNewsList();

      setTimeout(() => {
        window.scrollTo(0, 500);
        // console.log(document.getElementById("news"));
        // document.getElementById("news").scrollTo({top: 0, behavior: 'smooth'});
      }, 100);
    },
    // 获取公司动态列表
    getNewList(item) {
      this.$router.push({
        path: "/pages/news/detail",
        query: { id: item.id, current: 2 },
      });
    },
  },
  // watch: {
  //   current: {
  //     handler: function (n, o) {
  //       if (n != o && this.listData[this.current].list.length == 0) {
  //         this.getNewsList()
  //       }
  //     },
  //     deep: true
  //   }
  // }
};
</script>

<style lang="less" scoped>
.nodata1 {
  img {
    display: block;
    width: 700px;
    height: auto;
    margin: 50px auto;
  }
  p {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    text-align: center;
  }
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
}
.pagination {
  text-align: right;
  width: 1200px;
  margin: 0 auto 20px;
}
.wraps {
  background: #fafafa !important;
  padding-top: 120px;
}

.banner {
  width: 100%;
  display: block;
}

.content {
  width: 1200px;
  margin: 48px auto;

  .tabs-nav {
    // border-bottom: 1px solid #f5f5f5;
    padding: 25px 0 20px;
  }

  .nav-content {
    display: flex;
    align-items: center;
    justify-content: center;

    .item {
      font-size: 24px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 23px;
      margin-right: 115px;
      div {
        cursor: pointer;
      }
      .active {
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff6019;
        line-height: 23px;
      }
    }
  }

  .box {
    background: #f9f9f9;
    margin-top: 38px;
    flex: 1;
    .dynamics-list {
      .items {
        display: flex;
        cursor: pointer;
        border-bottom: 1px solid #cdd2d1;
        padding: 30px 0;
        .time {
          > div:first-child {
            font-family: Arial;
            font-weight: 400;
            font-size: 26px;
            color: #999999;
            line-height: 27px;
            margin-bottom: 12px;
          }
          > div:last-child {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
            border: 1px solid #999999;
            padding: 3px 4px 0px;
            display: inline-flex;
          }
        }
        .line1 {
          width: 30px;
          height: 1px;
          background: #999999;
          margin: 15px 37px;
        }
        .name {
          flex: 1;
          .tit {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 22px;
            color: #333333;
            margin-bottom: 36px;
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          .desc {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            min-height: 47px;
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        &:hover{
          .tit {
            color: #FF6019;
          }
        }
        .img {
          margin-left: 65px;
          img {
            width: 350px;
            height: 196px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue